export default __webpack_public_path__ + "static/media/f_zmije_obecna-min.514e7bd9.jpg";